import { PREVIEW_VOLUME_KEY } from './constants.ts';

export function readSavedVolume(): number {
  const saved = localStorage.getItem(PREVIEW_VOLUME_KEY);

  if (saved === null) {
    return 1;
  }

  const volume = Number(saved);

  return Number.isFinite(volume) && volume >= 0 && volume <= 1 ? volume : 1;
}

export function saveVolume(volume: number): void {
  localStorage.setItem(PREVIEW_VOLUME_KEY, String(volume));
}

export function getAdDimensions() {
  const DEFAULT_IMA_VIDEO_SIZES = [320, 180] as const;
  // First resolution meeting requirements is picked, so order matters
  const IMA_VIDEO_SIZES = [[3840, 2160], [1920, 1080], [1280, 720], [640, 360], DEFAULT_IMA_VIDEO_SIZES] as const;

  const adWidth = window.innerWidth * 0.8;
  const adHeight = window.innerHeight * 0.8;

  for (let i = 0; i < IMA_VIDEO_SIZES.length; i++) {
    const [width, height] = IMA_VIDEO_SIZES[i];

    if (adWidth >= width && adHeight >= height) {
      return IMA_VIDEO_SIZES[i];
    }
  }

  return DEFAULT_IMA_VIDEO_SIZES;
}
